/* eslint-disable max-len */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { faSquare, faSquareCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { updatePath } from './actions';

import style from './style.module.scss';

import Slider from './Slider';

const ContinuousSpeedControls = () => {
  const dispatch = useDispatch();
  const minPan = useSelector(({ mapping: { preview: { continuousSpeed: { pan: { min } } } } }) => min);
  const maxPan = useSelector(({ mapping: { preview: { continuousSpeed: { pan: { max } } } } }) => max);
  const pan = useSelector(({ mapping: { preview: { continuousSpeed: { pan: { value } } } } }) => value);

  const minTilt = useSelector(({ mapping: { preview: { continuousSpeed: { tilt: { min } } } } }) => min);
  const maxTilt = useSelector(({ mapping: { preview: { continuousSpeed: { tilt: { max } } } } }) => max);
  const tilt = useSelector(({ mapping: { preview: { continuousSpeed: { tilt: { value } } } } }) => value);
  const updatePosition = useSelector(({ mapping: { preview: { continuousSpeed: { updatePosition: val } } } }) => val);

  const minZoom = useSelector(({ mapping: { preview: { continuousSpeed: { zoom: { min } } } } }) => min);
  const maxZoom = useSelector(({ mapping: { preview: { continuousSpeed: { zoom: { max } } } } }) => max);
  const zoom = useSelector(({ mapping: { preview: { continuousSpeed: { zoom: { value } } } } }) => value);

  return (
    <div className={style.speedContainer}>
      <span>Continuous Move Speed</span>
      <div className={style.wrapper}>
        <div>
          <span>Pan</span>
          <div className={style.rangeWrapper}>
            <Slider
              path="preview.continuousSpeed.pan.value"
              min={minPan}
              max={maxPan}
              val={pan}
            />
          </div>
        </div>
        <div>
          <span>Tilt</span>
          <div className={style.rangeWrapper}>
            <Slider
              path="preview.continuousSpeed.tilt.value"
              min={minTilt}
              max={maxTilt}
              val={tilt}
            />
          </div>
        </div>
        <div>
          <span>Zoom</span>
          <div className={style.rangeWrapper}>
            <Slider
              path="preview.continuousSpeed.zoom.value"
              min={minZoom}
              max={maxZoom}
              val={zoom}
            />
          </div>
        </div>
        <button
          type="button"
          onClick={() => {
            dispatch(updatePath('preview.continuousSpeed.updatePosition', !updatePosition));
          }}
        >
          <span>Track on Move</span>
          <FontAwesomeIcon icon={updatePosition ? faSquareCheck : faSquare} />
        </button>
      </div>
    </div>
  );
};


export default ContinuousSpeedControls;
